/**
  A component that displays onboarding application for current user.
 **/
export const DashboardOnboardingContainerComponent = {
    template: `<apex-onboarding-dashboard ng-if="$ctrl.isLoaded"
                                          user-role="$ctrl.userRole" employee="$ctrl.employee" applications="$ctrl.applications" modal-title="$ctrl.modalTitle"></apex-onboarding-dashboard>`,
    require: {
        dashboardContext: "^apexDashboardContent"
    },
    controller: class DashboardOnboardingContainer {
        constructor($q, employeeService, onboardingDocumentService, permissionGrantService) {
            'ngInject'
            this.$q = $q
            this.employeeService = employeeService;
            this.onboardingDocumentService = onboardingDocumentService;
            this.permissionGrantService = permissionGrantService;
        }

        $onInit() {
            this.isLoaded = false;
            console.log('begin');
            return this.employeeService.retrievePermissions({ stateName: "application-status" }).then((access) => {
                if (!access.CanUpdate) {
                    console.log('Onboarding access is denied, stopping loading dashboard.');
                    return null;
                }
                return this.employeeService.retrieveIdentity();
            }).then((employee) => {
                if (!employee) {
                    console.log('Onboarding access is denied, stopping loading dashboard.');
                    return null;
                }
                this.employee = employee;
                return this.onboardingDocumentService.getUserRole(this.employee.UserName);
            }).then((userRole) => {
                if (!userRole) {
                    return null;
                }
                this.userRole = userRole;
                this.userName = this.employee.UserName;
                //if (this.userRole === 'Owner') {
                //    applicationPromise.push(this.onboardingDocumentService.retrieveApplicationForOwner(this.userName));
                //} else
                if (this.userRole === 'Owner' || this.userRole === 'Employee' || this.userRole === 'PayrollAdmin') {
                    this.dashboardContext.activateDashboard({
                        visible: true,
                        count: 1,
                    });
                    this.isLoaded = true;
                    /*return this.$q.when();//applicationPromise.push(this.onboardingDocumentService.retrieveApplication(this.userName));*/
                } else {
                    this.isLoaded = true;
                    return this.$q.reject("Permission Denied for Role"); //applicationPromise.push(Promise.resolve(null)); // Handle unexpected roles
                }
            }).catch((error) => {
                this.isLoaded = false;
                console.error('An error occurred while retrieving applications:', error);
                this.dashboardContext.activateDashboard({
                    visible: false,
                    count: 0,
                });
            });
        }


    }
}
